import { OrbitControls, Environment, ContactShadows } from "@react-three/drei";
import { Canvas } from "@react-three/fiber";
import React, { Suspense } from "react";
import MidiKeyboardModel from './MidiKeyboardModel';
import { useSpring, animated } from '@react-spring/three'
import { useScreenSize } from "../../styles/media-queries";


function _BackgroundScene({ loaded = true, ...rest }) {
    const { light } = useSpring({ light: loaded ? 1 : 0 })
    const { phone } = useScreenSize()
    return <group>
        {phone && <group>
            <ambientLight intensity={.2} color={"#ffe7f5"} />
            <spotLight intensity={3} color="#efdbff" position={[128.35, 30.92, 32.63]} />
            <spotLight intensity={2} color="#ffcaea" position={[1028.35, 3000.92, 32.63]} angle={0.4} />
        </group>}
        <Suspense fallback={null}>
            <Environment files={"/kiara_1_dawn_1k.hdr"} />
            <MidiKeyboardModel />
        </Suspense>

        <ContactShadows rotation-x={Math.PI / 2} position={[0, -4.5, 0]} opacity={0.4} width={20} height={20} blur={2} far={4.5} />

    </group>
}
export default function BackgroundScene({ ...rest }) {

    return (
        <Canvas shadows dpr={[1, 2]} {...rest} camera={{ position: [0, 0, 0], fov: 35 }} style={{ opacity: 0.8, width: '100vw', height: '100vh', position: 'absolute', left: 0, right: 0, background: "#121212" }}>
            <_BackgroundScene />

        </Canvas>
    )
};
